import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { MainContext } from '@blaze-cms/nextjs-components';
import { getWrappedValueWithLink } from '../../../../helpers';
import { parseBooleanValues } from '../../helpers';
const HeadingLargeSummaryContent = ({
  summaryPropsWithContent
}) => {
  const {
    itemId
  } = useContext(MainContext);
  return summaryPropsWithContent.map(([key, value], index) => {
    const dynamicKey = [itemId, index].join('-');
    const wrappedValue = parseBooleanValues(getWrappedValueWithLink(value, null, itemId), key);
    return /*#__PURE__*/React.createElement(Fragment, {
      key: dynamicKey
    }, wrappedValue);
  });
};
HeadingLargeSummaryContent.propTypes = {
  summaryPropsWithContent: PropTypes.array.isRequired
};
export default HeadingLargeSummaryContent;
//# sourceMappingURL=HeadingLargeSummaryContent.js.map